export const SET_UNCUBES_SERVER_READY = 'SET_UNCUBES_SERVER_READY';
export const STORE_KPI = 'STORE_KPI';
export const UPDATE_KPI = 'UPDATE_KPI';
